var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "post-list" },
    [
      _c(
        "div",
        { staticClass: "post-list__row row" },
        _vm._l(_vm.pageOfItems, function (post, index) {
          return _c(
            "div",
            { key: index, staticClass: "post-list__single col" },
            [
              _c(
                "a",
                {
                  staticClass: "post-list__single__img",
                  attrs: { href: post.url, title: post.title },
                },
                [_c("img", { attrs: { src: post.image, alt: post.title } })]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "post-list__single__wrapper" }, [
                _c(
                  "div",
                  { staticClass: "post-list__single__meta heading-small" },
                  [
                    _vm._v(
                      "\n                    BLOG POST " +
                        _vm._s(post.date) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "post-list__single__title",
                    attrs: { href: post.url, title: post.title },
                  },
                  [
                    _c("h4", {
                      ref: "title",
                      refInFor: true,
                      domProps: { innerHTML: _vm._s(post.title) },
                    }),
                  ]
                ),
                _vm._v(" "),
                post.authorName
                  ? _c("div", { staticClass: "post-list__single__author" }, [
                      _vm._v(
                        "\n                    By " +
                          _vm._s(post.authorName) +
                          " "
                      ),
                      post.authorDesc
                        ? _c("span", [_vm._v("- " + _vm._s(post.authorDesc))])
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "post-list__single__excerpt" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(post.excerpt) +
                      "\n                "
                  ),
                ]),
              ]),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("jw-pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.posts.length > 8,
            expression: "posts.length > 8",
          },
        ],
        attrs: {
          pageSize: 8,
          items: _vm.posts,
          styles: _vm.customStyles,
          labels: _vm.customLabels,
        },
        on: { changePage: _vm.onChangePage },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }